import type { ContactSectionConfigType } from '@/components/sections/ContactSection/ContactSection.types';

export const CONTACT_SECTION_CONFIG_RO: ContactSectionConfigType = {
    title: 'Contact',
    cardsContent: [
        {
            id: 1,
            className: 'bg-green-100 !p-8',
            content: {
                titles: ['M: <a href="mailto:info@paypo.ro">info@paypo.ro</a>'],
                text: 'Răspundem la majoritatea întrebărilor în 48 de ore.',
            },
            cta: {
                children: 'Trimite-ne un mesaj',
                variant: 'primary',
                href: `mailto:info@paypo.ro`,
                'data-test-id': 'contact-mail-redirect-button',
                className: 'text-nowrap',
            },
        },
        {
            id: 2,
            className: 'bg-purple-100 !p-8',
            content: {
                titles: ['T: 0312 294 746'],
                text: 'Serviciul Relații cu clienții este disponibil de luni până vineri între orele 08:00-18:00.',
            },
            cta: {
                children: 'Sună-ne',
                variant: 'secondary',
                href: `tel:0312294746`,
                'data-test-id': 'contact-phone-redirect-button',
                className: 'text-nowrap',
            },
        },
    ],
};
